import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_VENDORS, ADD_VENDOR, UPDATE_VENDOR, UPDATE_VENDOR_EXP_EXPENSE
} from 'redux/actionTypes';
import { incrementIDGen } from '.';
import { vendor } from 'constants/idGenType';

export const getVendors = () => (dispatch, getState) => {
  axiosClient
    .get('/api/vendors', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_VENDORS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addVendor = (newVendor, userId) => (dispatch, getState) => {
  axiosClient
    .post('/api/vendors', newVendor, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: userId, field: vendor }));
      dispatch({
        type: ADD_VENDOR,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateVendor = (updatedVendor) => (dispatch, getState) => {
  axiosClient
    .patch('/api/vendors', updatedVendor, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_VENDOR,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addVendorExpectedExpense = (expenseInfo) => (dispatch, getState) => {
  axiosClient
    .patch('/api/vendors/expected', expenseInfo, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_VENDOR_EXP_EXPENSE,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};